module.exports = __webpack_public_path__ + "static/media/404-manhole-BD-colors.f0261fc5.svg";